import script from "./captchaField.vue?vue&type=script&setup=true&lang=ts"
export * from "./captchaField.vue?vue&type=script&setup=true&lang=ts"

import "./captchaField.vue?vue&type=style&index=0&id=842cddb0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-842cddb0"]])

export default __exports__